<div class="fb-filter-product-preview flex flex-col justify-center items-center">
	<a class="w-full">
		<div class=" px-3 pt-3 pb-3">
			<div class="w-full h-[120px] md:h-[250px] rounded md:rounded-xl fb-skeleton"></div>
		</div>

		<div class="text-transparent text-xs md:text-sm mt-3 mb-1.5 mx-3 fb-skeleton w-[70%] rounded">pr</div>
		<div class="text-transparent text-base mb-1.5 mx-3 font-medium fb-skeleton w-[90%] rounded">pr</div>

		<div class="flex justify-start items-center mb-3 mt-2 text-xl font-medium mx-3
		text-transparent fb-skeleton w-[80%] rounded">
			pr
		</div>
	</a>

	<div class="px-3 pb-3 w-full flex items-center gap-2">
		<button class="w-full bg-[#fffcf7] rounded md:rounded-lg border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm fb-skeleton"
				type="submit">

		</button>
		<div class="w-max fb-skeleton bg-[#fffcf7] rounded md:rounded-lg border-2 border-[#8E7862] text-[#8E7862] py-1.5 px-1 cursor-pointer">
		</div>
	</div>
</div>
